"use client";
import { FallBackLoading } from "@/_components/ui/Fallback";
import { GetPosts, Post } from "@/_services/graphql/models/Posts";
import { Box, Flex, Text, VStack } from "@chakra-ui/react";
import Link from "next/link";
import "react-multi-carousel/lib/styles.css";
import { blogLinkBuilder } from "@/_utils";
import { useTranslations } from "next-intl";

interface Props {
  allPost: GetPosts;
  isLoading: boolean;
}

export const LatestPosts = ({ allPost, isLoading = true }: Props) => {
  const t = useTranslations("landing.blog");
  const renderNewsCard = (p: Post, index: number) => {
    return (
      <Link
        href={blogLinkBuilder(p.slug.current)}
        key={index}
        style={{ borderBottom: "none" }}
      >
        <Flex
          color="white"
          key={index}
          bgImage={`url(${p.mainImage.asset.url})`}
          bgSize="cover"
          rounded="4xl"
          w={{ base: "21rem", md: "28rem" }}
          h={{ base: "14rem", md: "18rem" }}
          align="flex-end"
          pos="relative"
          transition="all 0.3s"
          _hover={{ transform: "translateY(-10px)" }}
        >
          <VStack
            align="flex-start"
            gap={2}
            p={4}
            color="white"
            bg="linear-gradient(0deg, rgb(63, 63, 63), rgba(60, 60, 60, 0.8), rgba(185, 185, 185, .0));"
            roundedBottom="4xl"
            backdropFilter="blur(1px)"
          >
            <Box
              w="fit-content"
              backdropFilter="blur(10px)"
              py={1}
              px={2}
              rounded="full"
              bg="neutral.100"
              shadow="shadow-lg"
            >
              <Text textStyle="xs" color="neutral.800" fontWeight="light">
                #{" "}
                {p.categories?.length
                  ? p.categories[0].name
                  : t("search.uncategorized")}
              </Text>
            </Box>
            <Text
              color="inherit"
              textStyle="md"
              fontFamily="heading"
              fontWeight="light"
            >
              {p.title}
            </Text>
            {/* <Text color="inherit" textStyle="xs" lineClamp={2}>
              {p.shortDescription}
            </Text> */}
          </VStack>
        </Flex>
      </Link>
    );
  };

  return (
    <Box mt={{ base: 10, md: 20 }}>
      <Text
        textStyle={{ base: "3xl", md: "4xl" }}
        fontFamily="heading"
        fontWeight="light"
        mb={8}
        color="neutral.700"
      >
        {t("latest_posts")}
      </Text>

      {!isLoading ? (
        <Flex overflowX="auto" py={4}>
          <Flex gap={{ base: 4, md: 8 }}>
            {allPost.map((p, index) => renderNewsCard(p, index))}
          </Flex>
        </Flex>
      ) : (
        <FallBackLoading />
      )}
    </Box>
  );
};
